import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Sort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {DateUtil} from '../../../../common/util/DateUtil';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {MatStepper} from '@angular/material/stepper';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {EMPTY, forkJoin, Subject, Subscription} from 'rxjs';
import {catchError, debounceTime, take, takeUntil, finalize} from 'rxjs/operators';
import {KeycloakService} from 'keycloak-angular';
import {PayerService} from 'src/app/modules/ent/services/payer.service';
import {ClaimDisplayDTO} from '../../../models/claim/ClaimDisplayDTO';
import {ClaimService} from '../../../services/claim.service';
import {ConfirmationDialogComponent} from 'src/app/modules/common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {ErrorDialogComponent} from '../../../../common/dialogs/error-dialog/error-dialog.component';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {ActivityHistoryDialogComponent} from '../../dialogs/activity-history-dialog/activity-history-dialog.component';
import {BankFileService} from '../../../../ent/services/bank-file.service';
import {BankAccountLinkDTO} from '../../../../ent/models/BankAccountLinkDTO';
import {AddBankAccountDialogComponent} from '../../../../ent/components/dialogs/add-bank-account-dialog/add-bank-account-dialog.component';
import {PayerDTO} from 'src/app/modules/ent/models/PayerDTO';
import {Common, getSortDirection, stringNullOrEmpty} from '../../../../common/util/Util';
import {PagedResponseDTO} from '../../../../common/models/PagedResponseDTO';
import {LookupService} from '../../../../common/services/lookup.service';
import {SharedService} from '../../../../common/services/shared-service';
import {CreateNameValueDTO, NameValueDTO} from '../../../../common/models/NameValueDTO';
import {PagedFilterDTO, PagedFilterDTONew} from '../../../../common/models/PagedFilterDTO';
import {PagedRequestDTO} from '../../../../common/models/PagedRequestDTO';
import {TableControl} from '../../../../common/models/TableControl';
import {BankAccountDTO} from '../../../../ent/models/BankAccountDTO';
import {Role} from '../../../types/role.enum';
import {PaymentDTO} from '../../../models/payment/PaymentDTO';
import {PaymentsService} from '../../../services/payments.service';
import {ClmFunctions} from '../../../common/functions/clm.functions';
import {ClaimType} from '../../../types/claim-type';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {WorkflowResultDTO} from '../../../models/WorkflowResultDTO';
import {AdjudicationStatus} from '../../../types/adjudication-status.enum';
import {ProcessingStatus} from '../../../types/processing-status.enum';
import {DisplayIcon} from '../../../../common/components';
import {EntRequestBuilder} from '../../../../ent/services/ent-request-builder';
import {BankAccountService} from '../../../../ent/services/bank-account.service';
import {ProcessingClass, ProcessingClassDisplayValue} from '../../../types/processing-class.enum';
import {FilterPayeesDTO} from '../../../models/FilterPayeesDTO';
import {MatOption} from '@angular/material/core';
import {LoadingSpinnerCounterService} from '../../../../common/services/loading-spinner-counter.service';
import {EntityTable} from '../../../../common/types/entity-table.enum';
import {LookupValue} from '../../../types/lookup-value.enum';
import {GenericReportDialogComponent} from '../../../../common/components/dialogs/generic-report-dialog/generic-report-dialog.component';

const BENEFICIARY = 'Beneficiary';
const PROVIDER = 'Provider';
const ESTATE = 'Estate';
const ALL_SUB_CLASSES = 'All Sub Classes';

@Component({
  selector: 'app-execute-payment',
  templateUrl: './execute-payment-view.component.html',
  styleUrls: [
    '../../../../../../styles/global/_add-view-edit-styles.scss',
    './execute-payment-view.component.scss'
  ]
})
export class ExecutePaymentViewComponent implements OnInit, AfterViewChecked, OnDestroy {
  readonly dateFormat = DateUtil.dateFormat;
  readonly debounceTime = Common.DEBOUNCE_TIME;
  readonly destroyed$ = new Subject();
  readonly lookupValue = LookupValue;
  readonly ClmFunctions = ClmFunctions;
  readonly ClaimType = ClaimType;
  readonly DisplayIcon = DisplayIcon;
  readonly allProducts = {name: 'All Products', value: 0};

  userRoles: string[];
  userFirstLastName: string;
  totalAmount: number;
  today: Date;

  // Form Controls
  paymentParameterFormGroup: FormGroup;
  processingClassFormControl: FormControl;
  payeeTypeFormControl: FormControl;
  productFormControl: FormControl;
  claimFromDateFormControl: FormControl;
  claimToDateFormControl: FormControl;
  payerNameFormControl: FormControl;
  payeeNameFormControl: FormControl;
  fromBankAccountFormControl: FormControl;
  executionDateFormControl: FormControl;
  showUpfrontPaidFormControl: FormControl;

  // Payer
  payerName: string;
  payerIds: string[];
  payerNameTextChanged = new Subject<string>();
  payerNameSubscription: Subscription;
  availablePayers: PayerDTO[];
  selectedPayers: PayerDTO[];

  // Payee
  payeeName: string;
  payeeIds: string[];
  payeeTypes: string[];
  payeeNameTextChanged = new Subject<string>();
  payeeNameSubscription: Subscription;
  availablePayees: NameValueDTO[] = [];
  selectedPayees: NameValueDTO[] = [];

  helpInfo: HelpDTO[];
  fromBankAccounts: BankAccountDTO[];
  funeralProducts: NameValueDTO[];
  medicalProducts: NameValueDTO[];
  transactionIdsList: [{ transactionId: number, created: Date, createdBy: string }];
  processingClasses: string[];
  processingSubClass: string;
  processingSubClassesMedical: NameValueDTO[];
  processingSubClassesFuneral: NameValueDTO[];

  length = 100;
  pageSize = 25;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  transactionTableControl: TableControl;
  transactionDataSource: ClaimDisplayDTO[];
  transactionDisplayedColumns: string[];
  transactionDisplayedColumnsMedical: string[] = [
    'select',
    'icons',
    'transactionId',
    'processingClass',
    'receivedDate',
    'insuredPersonName',
    'insuredPersonBankAccount',
    'providerName',
    'providerBankAccount',
    'policyNumber',
    'caseNumber',
    'assessingStatus',
    'payTo',
    'casePayments',
    'benefitAmount',
    'netAmountForCase',
    'payAmount',
    'warn'
  ];
  transactionDisplayedColumnsFuneral: string[] = [
    'select',
    'icons',
    'transactionId',
    'processingClass',
    'receivedDate',
    'insuredPersonName',
    'beneficiaryName',
    'beneficiaryBankAccount',
    'providerName',
    'policyNumber',
    'caseNumber',
    'assessingStatus',
    'payTo',
    'casePayments',
    'benefitAmount',
    'warn'
  ];

  @ViewChild('transactionPaginator', {static: false}) transactionPaginator: MatPaginator;
  @ViewChild('stepper') private paymentStepper: MatStepper;
  @ViewChild('allSelected') private allSelected: MatOption;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private paymentsService: PaymentsService,
    private payerService: PayerService,
    private keycloakService: KeycloakService,
    private formBuilder: FormBuilder,
    private claimService: ClaimService,
    private datePipe: DatePipe,
    private bankFileService: BankFileService,
    private sharedService: SharedService,
    private lookupService: LookupService,
    private bankAccountService: BankAccountService,
    private loadingSpinnerCounterService: LoadingSpinnerCounterService
  ) {
    this.transactionTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      'transactionId',
      'desc',
      'transactionId',
      ''
    );
    this.payerName = '';
    this.payeeName = '';
    this.processingClasses = [ProcessingClassDisplayValue.Funeral, ProcessingClassDisplayValue.Medical];
    this.payeeTypes = [BENEFICIARY, PROVIDER];
    this.selectedPayees = [];
    this.selectedPayers = [];
    this.payerIds = [];
    this.payeeIds = [];
    this.totalAmount = 0.0;
    this.today = new Date();
  }

  ngOnInit(): void {
    this.initFormControls();
    this.initSubscriptions();
    this.userRoles = this.keycloakService.getUserRoles();
    this.keycloakService.loadUserProfile().then(profile => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
    this.getListOfPayers('', true);
    this.getListOfPayees('');
    this.getAllLookupValues();
    this.sharedService.getHelpInfo('Payment');
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.payerNameSubscription.unsubscribe();
    this.payeeNameSubscription.unsubscribe();
  }

  getAllLookupValues(): void {
    this.getListOfLookupValues(this.lookupValue.ClientBankAccount);
    this.getListOfLookupValues(this.lookupValue.FuneralProduct);
    this.getListOfLookupValues(this.lookupValue.MedicalProduct);
    this.getListOfLookupValues(this.lookupValue.ProcessingSubClassFuneral);
    this.getListOfLookupValues(this.lookupValue.ProcessingSubClassMedical);
  }

  initFormControls(): void {
    this.payerNameFormControl = new FormControl('');
    this.payeeNameFormControl = new FormControl('');
    this.processingClassFormControl = new FormControl('', Validators.required);
    this.payeeTypeFormControl = new FormControl(BENEFICIARY, Validators.required);
    this.productFormControl = new FormControl([this.allProducts.name], Validators.required);
    this.claimFromDateFormControl = new FormControl(new Date(new Date().setDate(this.today.getDate() - 1)), Validators.required);
    this.claimToDateFormControl = new FormControl(this.today, Validators.required);
    this.paymentParameterFormGroup = this.formBuilder.group({
      processingClass: this.processingClassFormControl,
      payeeType: this.payeeTypeFormControl,
      product: this.productFormControl,
      claimsFrom: this.claimFromDateFormControl,
      claimsTo: this.claimToDateFormControl
    });
    this.fromBankAccountFormControl = new FormControl('', Validators.required);
    this.executionDateFormControl = new FormControl(this.today, Validators.required);
    this.showUpfrontPaidFormControl = new FormControl(false, [Validators.required]);
  }

  initSubscriptions(): void {
    this.payerNameSubscription = this.payerNameTextChanged.pipe(
      debounceTime(this.debounceTime)
    ).subscribe((searchText) => {
      this.getListOfPayers(searchText);
    });

    this.payeeNameSubscription = this.payeeNameTextChanged.pipe(
      debounceTime(this.debounceTime)
    ).subscribe((searchText) => {
      this.getListOfPayees(searchText);
    });
  }

  /*
  * VALIDATORS
  */

  // TODO: Refractor validation methods here

  /*
  * PAGE METHODS
  */

  viewClaimDetails($event: MouseEvent, transactionId: string): void {
    this.dialog.open(ActivityHistoryDialogComponent, {
      width: '80vw',
      height: '80vh',
      data: {id: transactionId, field: 'encounterByEncounterId.transactionByTransactionId.transactionId'}
    });
  }
  getCaseUrl(row: ClaimDisplayDTO): string {
    return ClmFunctions.getCaseUrl(row, this.router);
  }

  reviewClaim(event: MouseEvent, id: number): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/claim-management/review-claim/${id}`]));
    window.open(url, '_blank');
  }

  allowReview(row): boolean {
    return row.processingStatus !== 'Authorisation Claimed' && row.processingStatus !== 'Payment Run Complete' && row.processingStatus !== 'Paid';
  }

  clearForm(): void {
    this.processingClassFormControl.setValue('');
    this.payeeTypeFormControl.setValue(BENEFICIARY);
    this.productFormControl.setValue([this.allProducts.name]);
    this.claimFromDateFormControl.setValue(new Date(new Date().setDate(this.today.getDate() - 1)));
    this.claimToDateFormControl.setValue(this.today);
    this.clearDropBoxArrays();
    this.getListOfPayees('');
    this.getListOfPayers('', true);
  }

  processingClassSelectionChange(): void {
    if (this.processingClassFormControl.value === ProcessingClassDisplayValue.Funeral) {
      this.defaultProductFormControlSelectedValues(this.funeralProducts, false);
      let funeralSubClasses = this.processingSubClassesFuneral;
      funeralSubClasses = funeralSubClasses != null ? funeralSubClasses.sort((a, b) => a.value - b.value) : [];
      this.processingSubClass = funeralSubClasses.length > 0 ? funeralSubClasses[0].name : '';
      this.payeeTypeFormControl.setValue(BENEFICIARY);
      this.payeeTypeFormControl.disable();
      this.transactionDisplayedColumns = this.transactionDisplayedColumnsFuneral;
    }
    else {
      this.productFormControl.setValue([...this.medicalProducts.map(item => item.name), this.allProducts.name]);
      let medicalSubClasses = this.processingSubClassesMedical;
      medicalSubClasses = medicalSubClasses != null ? medicalSubClasses.sort((a, b) => a.value - b.value) : [];
      this.processingSubClass = medicalSubClasses.length > 0 ? medicalSubClasses[0].name : '';
      this.payeeTypeFormControl.setValue(PROVIDER);
      this.payeeTypeFormControl.enable();
      this.transactionDisplayedColumns = this.transactionDisplayedColumnsMedical;
    }
    this.clearPayeeDropBoxArrays();
    this.getListOfPayees(this.payeeNameFormControl.value);
    this.getListOfBankAccounts();
  }

  onProcessingSubClassSelectionChanged(value: string) {
    this.processingSubClass = value;
    this.getListOfPayees(this.payeeNameFormControl.value);
    this.getListOfBankAccounts();
  }

  payeeTypeSelectionChange(): void {
    this.clearPayeeDropBoxArrays();
    this.getListOfPayees(this.payeeNameFormControl.value);
    this.getListOfBankAccounts();
  }

  productSelectionChange(shouldAllProductsBeDeselected: boolean): void {
    if (this.allSelected.selected && shouldAllProductsBeDeselected) {
      this.allSelected.deselect();
    }
    this.clearPayeeDropBoxArrays();
    this.getListOfPayees(this.payeeNameFormControl.value);
    this.getListOfBankAccounts();
  }

  dateToSelectionChange(): void {
    this.clearPayeeDropBoxArrays();
    this.getListOfPayees(this.payeeNameFormControl.value);
  }

  dateFromSelectionChange(): void {
    this.clearPayeeDropBoxArrays();
    this.getListOfPayees(this.payeeNameFormControl.value);
  }

  onUpfrontPaidToggleToggle(event: MatSlideToggleChange): void {
    this.clearPayeeDropBoxArrays();
    this.getListOfPayees(this.payeeNameFormControl.value);
  }
  clearSelectedPayees(): void {
    this.clearPayeeDropBoxArrays();
    this.getListOfPayees('');
  }

  addAllPayeesToSelectedList(): void {
    this.availablePayees.forEach(payee => {
      this.selectedPayees.push(payee);
    });
    this.availablePayees = [];
  }

  onInputChangedSearchPayers(name): void {
    this.payerName = name;
    this.payerNameTextChanged.next(name);
  }

  onInputChangedSearchPayees(name): void {
    this.payeeName = name;
    this.payeeNameTextChanged.next(name);
  }

  dropPayee(event: CdkDragDrop<string[]>): void {
    this.dragDropEvent(event);
    this.getListOfBankAccounts();
  }

  dropPayer(event: CdkDragDrop<string[]>): void {
    this.dragDropEvent(event);
    this.getListOfPayees(this.payeeNameFormControl.value);
    this.getListOfBankAccounts();
  }

  getInfoTooltip(inputName: string): string {
    return this.sharedService.getInfoTooltip(inputName);
  }

  disableFinishButton(): boolean {
    let isDisabled = false;
    if (this.loadingSpinnerCounterService.isLoading()) {
      isDisabled = true;
    }
    else if (!this.transactionDataSource || this.transactionDataSource.length <= 0 || !this.transactionIdsList || this.transactionIdsList.length <= 0) {
      isDisabled = true;
    }
    // Ignore this check showUpfrontPaid is true
    else if (!this.atLeastOneAccountExists() && !this.showUpfrontPaidFormControl.value) {
      isDisabled = true;
    }
    // Ignore this check showUpfrontPaid is true
    else if (!this.atLeastOneNonNegativeAmountExists() && !this.showUpfrontPaidFormControl.value) {
      isDisabled = true;
    }

    if (this.disableButtonIfNotFinancialManager()) {
      isDisabled = true;
    }

    return isDisabled;
  }

  disableButtonIfNotFinancialManager(): boolean {
    let disabled = true;
    if (this.userRoles.find(role => role === Role.FinancialManager)) {
      disabled = false;
    }
    return disabled;
  }

  sortData($event: Sort): void {
    if (!$event.direction) {
      return;
    }
  }

  openErrorDialog(errorMessage: string): void {
    this.dialog.open(ErrorDialogComponent, {
      width: '40vw',
      data: errorMessage
    });
  }

  pageChanged($event: PageEvent): void {
    this.transactionTableControl.pageNumber = $event.pageIndex;
    this.transactionTableControl.pageSize = $event.pageSize;
    this.getListOfTransactions(this.transactionTableControl);
  }

  getBankAccountDisplayString(payeeBankAccount: BankAccountLinkDTO): string {
    return payeeBankAccount != null ? 'Edit Account' : 'Add Account';
  }

  getProviderBankAccountDisplayString(payeeBankAccount: BankAccountDTO): string {
    return payeeBankAccount != null ? 'Edit Account' : 'Add Account';
  }

  getFromBankAccountDisplayString(bankAccount: BankAccountDTO): string {
    return bankAccount.name + ' - ' + bankAccount.accountNumber;
  }

  openInsuredPersonBankAccountDialog(event: MouseEvent, insuredPersonId: number): void {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef = this.dialog.open(AddBankAccountDialogComponent, {
      width: '40vw',
      height: '80vh',
      data: {entityId: insuredPersonId, entityType: 'Insured Person'}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadClaims();
      }
    });
  }

  openProviderBankAccountDialog(event: MouseEvent, providerId: number): void {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef = this.dialog.open(AddBankAccountDialogComponent, {
      width: '40vw',
      height: '80vh',
      data: {entityId: providerId, entityType: PROVIDER}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadClaims();
      }
    });
  }

  getFinishTooltip(): string {
    let tooltip = '';
    if (this.disableFinishButton()) {
      tooltip = 'There are either no claims that match the search criteria, or all the payees are missing bank account information, or there are no transactions with non-negative amounts.';
    }
    if (this.disableButtonIfNotFinancialManager()) {
      tooltip = 'Only those from the financial team can execute payments';
    }
    return tooltip;
  }

  loadClaims(): void {
    if (!this.paymentParameterFormGroup.valid || !this.selectedPayees || this.selectedPayees.length === 0 || !this.selectedPayers || this.selectedPayers.length === 0) {
      this.sharedService.openSnackBar(`Please ensure at least 1 payee and 1 payer are selected.`, 'Dismiss');
      return;
    }

    this.payeeIds = [];
    this.selectedPayees.forEach(payee => {
      this.payeeIds.push(String(payee.value));
    });

    this.payerIds = [];
    this.selectedPayers.forEach(payer => {
      this.payerIds.push(String(payer.payerId));
    });

    this.getListOfTransactions(this.transactionTableControl);
    this.getListOfBankAccounts();

    this.paymentStepper.next();
  }

  executePayment(): void {
    // TODO: refractor service call out of page method
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: this.getPaymentConfirmationMessage()
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.showUpfrontPaidFormControl.value) {
          this.saveUpfrontPaidTransactions();
        }
        else {
          this.savePayment();
        }
      }
    });
  }

  getProducts(): NameValueDTO[] {
    let products: NameValueDTO[] = [];
    const funeralProducts = this.funeralProducts != null ? this.funeralProducts : [];
    const medicalProducts = this.medicalProducts != null ? this.medicalProducts : [];
    if (this.processingClassFormControl.value === ProcessingClassDisplayValue.Funeral) {
      products = funeralProducts;
    }
    else if (this.processingClassFormControl.value === ProcessingClassDisplayValue.Medical) {
      products = medicalProducts;
    }
    else {
      products = [...funeralProducts, ...medicalProducts];
    }
    return products;
  }

  toggleSelect(matCheckboxChange: MatCheckboxChange, transaction: ClaimDisplayDTO): void {
    if (matCheckboxChange != null && matCheckboxChange.checked) {
      if (this.showUpfrontPaidFormControl.value) {
        this.addSelectedTransaction(transaction);
      }
      else {
        if (this.getTransactionBankAccountByPayeeType(transaction) != null) {
          this.addSelectedTransaction(transaction);
          this.addToTotalAmount(transaction);
        } else {
          matCheckboxChange.source.checked = false;
          this.sharedService.openSnackBar('Payee is missing bank account information', 'Dismiss');
        }
      }
    } else {
      this.removeUnselectedTransaction(transaction);
      if (!this.showUpfrontPaidFormControl.value) {
        this.subtractFromTotalAmount(transaction);
      }
    }
  }

  isSelected(claimDisplayDTO: ClaimDisplayDTO): boolean {
    return this.transactionIdsList ? this.transactionIdsList.find(transaction => transaction.transactionId === claimDisplayDTO.transactionId) != null : false;
  }

  getSubClasses(): NameValueDTO[] {
    let subClasses: NameValueDTO[] = [];
    const processingSubClassesMedical: NameValueDTO[] = this.processingSubClassesMedical != null ? this.processingSubClassesMedical : [];
    const processingSubClassesFuneral: NameValueDTO[] = this.processingSubClassesFuneral != null ? this.processingSubClassesFuneral : [];

    if (this.processingClassFormControl.value === ProcessingClassDisplayValue.Medical) {
      subClasses = processingSubClassesMedical;
    }
    else if (this.processingClassFormControl.value === ProcessingClassDisplayValue.Funeral) {
      subClasses = processingSubClassesFuneral;
    }

    return subClasses;
  }

  onClickOpenPaymentLedgerReport($event: Event, row: ClaimDisplayDTO) {
    $event.preventDefault();
    $event.stopPropagation();

    this.dialog.open(GenericReportDialogComponent, {
      width: '70vw',
      height: '80vh',
      data: {
        heading: 'Net Payment Detail',
        reportURI: 'Payment_Ledger',
        reportParameters: `Transaction_ID=${row?.transactionId}&Provider_ID=${row?.providerId}`,
        showDownloadPdfReportButton: true,
        downloadPdfReportFileName: 'Payment_Ledger_Report'
      },
      panelClass: 'gd-payment-ledger-report-dialog'
    });
  }

  private dragDropEvent(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  private addToTotalAmount(transaction: ClaimDisplayDTO): void {
    const transactionTotalAmount = transaction.payAmount;
    this.totalAmount += transactionTotalAmount < 0 ? 0 : transactionTotalAmount;
  }

  private subtractFromTotalAmount(transaction: ClaimDisplayDTO): void {
    const transactionTotalAmount = transaction.payAmount;
    this.totalAmount -= transactionTotalAmount < 0 ? 0 : transactionTotalAmount;
  }

  private addSelectedTransaction(transaction: ClaimDisplayDTO): void {
    if (!this.transactionIdsList) {
      this.transactionIdsList = [{
        transactionId: transaction.transactionId,
        created: new Date(),
        createdBy: this.userFirstLastName
      }];
    } else {
      this.transactionIdsList.push({
        transactionId: transaction.transactionId,
        created: new Date(),
        createdBy: this.userFirstLastName
      });
    }
  }

  private removeUnselectedTransaction(transaction: ClaimDisplayDTO): void {
    const index = this.transactionIdsList.findIndex(transactionId => transactionId.transactionId === transaction.transactionId);
    if (index > -1) {
      this.transactionIdsList.splice(index, 1);
    }
  }

  private clearDropBoxArrays(): void {
    this.clearPayerDropBoxArrays();
    this.clearPayeeDropBoxArrays();
  }

  private clearPayerDropBoxArrays(): void {
    this.availablePayers = [];
    this.selectedPayers = [];
    this.payerIds = [];
  }

  private clearPayeeDropBoxArrays(): void {
    this.availablePayees = [];
    this.selectedPayees = [];
    this.payeeIds = [];
  }

  private getNumberOfMissingAccounts(): number {
    const missingAccounts: number[] = [];
    if (this.transactionDataSource) {
      this.transactionDataSource.forEach(transaction => {
        const bankAccount = this.getTransactionBankAccountByPayeeType(transaction);

        // If the bank account does not exist AND the related ID has not been added to the array yet
        if (this.isSelected(transaction) && bankAccount == null && !missingAccounts.find(id => transaction.transactionId === id)) {
          missingAccounts.push(transaction.transactionId);
        }
      });
    }
    return missingAccounts.length;
  }

  private atLeastOneAccountExists(): boolean {
    let accountExists = false;
    if (this.transactionDataSource) {
      for (const transaction of this.transactionDataSource) {
        const bankAccount = this.getTransactionBankAccountByPayeeType(transaction);

        if (bankAccount != null) {
          // Return true if at least 1 account exists
          accountExists = true;
          break;
        }
      }
    }
    return accountExists;
  }

  private atLeastOneNonNegativeAmountExists(): boolean {
    let nonNegativeAmountExists = false;
    const negativeAmounts: number[] = [];
    if (this.transactionDataSource) {
      this.transactionDataSource.forEach(transaction => {
        if (this.isSelected(transaction) && (transaction.payAmount >= 0)) {
          nonNegativeAmountExists = true;
        }
      });
    }
    return nonNegativeAmountExists;
  }

  private getTransactionBankAccountByPayeeType(transaction: ClaimDisplayDTO): BankAccountDTO | BankAccountLinkDTO {
    if (this.payeeTypeFormControl.value === 'Beneficiary' && this.processingClassFormControl.value === 'Funeral') {
      return transaction.beneficiaryBankAccount;
    }
    else if (this.payeeTypeFormControl.value === 'Beneficiary' && this.processingClassFormControl.value === 'Medical') {
      return transaction.insuredPersonBankAccount;
    }
    else {
      return transaction.providerBankAccount;
    }
  }

  private getPaymentConfirmationMessage(): string {
    let message = 'Do you want to mark the selected claims as Upfront Paid?';
    if (!this.showUpfrontPaidFormControl.value) {
      message = 'Do you want to execute the payment run? ';
      if (this.getNumberOfMissingAccounts() > 0) {
        message += `1 or more payees are missing bank account information and will be excluded from the process.`;
      }
    }
    return message;
  }

  private getBankFileEntries(paymentId: number): void {
    this.bankFileService.getBankFileEntriesByPaymentIdFnb(paymentId)
      .pipe(
        take(1),
        finalize(() => this.navigateToPaymentsPage())
      )
      .subscribe({
      next: (response) => {
        if (response != null && response.length > 0) {
          const accountNumber: string = this.getFromAccountByDisplayName(this.fromBankAccountFormControl.value).accountNumber;
          this.bankFileService.generateBankFile(response, accountNumber, paymentId);
          this.sharedService.openSnackBar(
            `The payment has executed successfully`,
            'Dismiss'
          );
        }
        else {
          this.sharedService.openSnackBar(
            `The banking file has failed to generate.`,
            'Dismiss'
          );
        }
      },
      error: () => {
        (errorResponse) => {
          this.sharedService.openErrorDialog(errorResponse?.error?.businessMessage);
        };
      }
    });
  }

  private getFromAccountByDisplayName(displayString: string): BankAccountDTO {
    return this.fromBankAccounts.find((item) => displayString === this.getFromBankAccountDisplayString(item));
  }

  private getFromAccountByName(accountName: string): BankAccountDTO {
    return this.fromBankAccounts.find((item) => accountName === item.name);
  }

  /*
  * SERVICE CALLS
  */

  private saveUpfrontPaidTransactions(): void {
    const transactionResult = new WorkflowResultDTO();
    transactionResult.result = AdjudicationStatus.Unknown;
    transactionResult.workflowStep = ProcessingStatus.UpfrontPaid;
    transactionResult.createdBy = this.userFirstLastName;

    if (this.transactionIdsList != null && this.transactionIdsList.length > 0) {
      const requests = this.transactionIdsList.map(x => {
        const result = {...transactionResult, transactionId: x.transactionId};
        return this.claimService.updateTransactionStatus(result).pipe(
          catchError(errorResponse => {
            this.sharedService.openErrorDialog(errorResponse?.error?.businessMessage);
            return EMPTY;
          })
        );
      });

      forkJoin(requests).subscribe(() => {
        this.sharedService.openSnackBar(
          `The claims have been successfully marked as Upfront Paid`,
          'Dismiss'
        );
        this.navigateToPaymentsPage();
      });
    }
  }

  private savePayment(): void {
    const paymentDTO: Omit<PaymentDTO, any> = this.getPaymentDTOPayload();

    this.paymentsService.savePayment(paymentDTO)
      .pipe(take(1))
      .subscribe({
        next: (response: PaymentDTO) => this.getBankFileEntries(response.paymentId),
        error: (errorResponse) => {
          this.sharedService.openErrorDialog(errorResponse?.error?.businessMessage);
          this.navigateToPaymentsPage();
        }
      });
  }

  private getPaymentDTOPayload(): Omit<PaymentDTO, any> {
    let payload: Omit<PaymentDTO, any>;
    payload = {
      createdBy: this.userFirstLastName,
      created: new Date(),
      bankAccountNumber: this.getFromAccountByDisplayName(this.fromBankAccountFormControl.value).accountNumber,
      transactionPayments: this.transactionIdsList,
      isActive: 1,
      paymentExecutionDate: new Date(this.executionDateFormControl.value),
      paymentType: CreateNameValueDTO(6, 'Payment Run') // 6 Matched DB side
    } as Omit<PaymentDTO, any>;
    return payload;
  }

  private getListOfTransactions(tableControl: TableControl): void {
    this.totalAmount = 0.0;

    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblTransaction;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = getSortDirection(tableControl.sortDirection);

    const pagedFilterDTO = new PagedFilterDTO();
    pagedFilterDTO.name = 'processingClassId';
    pagedFilterDTO.value = this.processingClassFormControl.value == ProcessingClassDisplayValue.Medical ? ProcessingClass.Medical.toString() : ProcessingClass.Funeral.toString();

    const pagedFilterProcessingStatus = new PagedFilterDTO();
    pagedFilterProcessingStatus.name = 'processingStatusId';
    pagedFilterProcessingStatus.value = '8'; // Ready for Settlement

    const pagedFilterAdjudicationStatus = new PagedFilterDTO();
    pagedFilterAdjudicationStatus.name = 'adjudicationStatusByAdjudicationStatusId';
    pagedFilterAdjudicationStatus.operator = 'in';
    pagedFilterAdjudicationStatus.value = '3,5';

    const pagedFilterTransactionType = new PagedFilterDTO();
    pagedFilterTransactionType.name = 'transactionTypeId';
    pagedFilterTransactionType.value = '2';

    const pagedFilterDateFromDTO = new PagedFilterDTO();
    if (this.claimFromDateFormControl.value != '') {
      pagedFilterDateFromDTO.name = 'receivedDate';
      pagedFilterDateFromDTO.value = this.datePipe.transform(this.claimFromDateFormControl.value, 'yyyyMMdd');
      pagedFilterDateFromDTO.operator = '>=';
    }

    const pagedFilterDateToDTO = new PagedFilterDTO();
    pagedFilterDateToDTO.name = 'receivedDate';
    pagedFilterDateToDTO.value = this.datePipe.transform(this.claimToDateFormControl.value, 'yyyyMMdd');
    pagedFilterDateToDTO.operator = '<=';

    const pagedFilterPayAmountDTO = new PagedFilterDTONew();
    pagedFilterPayAmountDTO.name = 'payAmount';
    pagedFilterPayAmountDTO.value = '0';
    pagedFilterPayAmountDTO.operator = this.showUpfrontPaidFormControl.value ? '<=' : '>';

    const pagedFilterProductDTO = new PagedFilterDTONew();
    if (!this.allSelected.selected) {
      const productIds = this.getSelectedProductIds();
      pagedFilterProductDTO.name = 'productByProductId';
      pagedFilterProductDTO.operator = 'in';
      pagedFilterProductDTO.value = productIds.toString();
    }

    const pagedFilterPayeeTypeDTO1 = new PagedFilterDTONew();
    let pagedFilterPayeeTypeDTO2 = null;
    if (this.payeeTypeFormControl.value === PROVIDER) {
      pagedFilterPayeeTypeDTO1.name = 'payTo';
      pagedFilterPayeeTypeDTO1.value = PROVIDER;
    }
    else if (this.payeeTypeFormControl.value === BENEFICIARY && this.processingClassFormControl.value === ProcessingClassDisplayValue.Funeral) {
      pagedFilterPayeeTypeDTO1.name = 'payTo';
      pagedFilterPayeeTypeDTO1.value = BENEFICIARY;
      pagedFilterPayeeTypeDTO1.logicGate = 'AND';
      pagedFilterPayeeTypeDTO1.bracket = '(';

      pagedFilterPayeeTypeDTO2 = new PagedFilterDTONew();
      pagedFilterPayeeTypeDTO2.name = 'payTo';
      pagedFilterPayeeTypeDTO2.value = ESTATE;
      pagedFilterPayeeTypeDTO2.logicGate = 'OR';
      pagedFilterPayeeTypeDTO2.bracket = ')';
    }
    else if (this.payeeTypeFormControl.value === BENEFICIARY && this.processingClassFormControl.value === ProcessingClassDisplayValue.Medical) {
      pagedFilterPayeeTypeDTO1.name = 'payTo';
      pagedFilterPayeeTypeDTO1.value = BENEFICIARY;
    }

    pagedRequestDTO.fieldMap = {};
    pagedRequestDTO.fieldMap[`processingClassByProcessingClassId`] = pagedFilterDTO;
    pagedRequestDTO.fieldMap[`processingStatusByProcessingStatusId`] = pagedFilterProcessingStatus;
    pagedRequestDTO.fieldMap[`adjudicationStatusByAdjudicationStatusId`] = pagedFilterAdjudicationStatus;
    pagedRequestDTO.fieldMap[`transactionTypeId`] = pagedFilterTransactionType;
    pagedRequestDTO.fieldMap[`receivedDate_1`] = pagedFilterDateFromDTO;
    pagedRequestDTO.fieldMap[`receivedDate_2`] = pagedFilterDateToDTO;
    pagedRequestDTO.fieldMap[`${pagedFilterPayeeTypeDTO2 != null ? 'payTo_1' : 'payTo'}`] = pagedFilterPayeeTypeDTO1;
    if (pagedFilterPayeeTypeDTO2 != null) {
      pagedRequestDTO.fieldMap[`payTo_2`] = pagedFilterPayeeTypeDTO2;
    }
    pagedRequestDTO.fieldMap[`productByProductId_1`] = pagedFilterProductDTO;
    pagedRequestDTO.fieldMap[`payAmount`] = pagedFilterPayAmountDTO;

    if (this.payeeIds && this.payeeIds.length > 0) {
      if (this.payeeTypeFormControl.value === BENEFICIARY) {
        const key = this.processingClassFormControl.value === ProcessingClassDisplayValue.Funeral ? 'insuredPersonByPayToNationalIdNumber' : 'insuredPersonByInsuredPersonId';
        const pagedFilterSelectedPayeesDTO = new PagedFilterDTO();
        pagedFilterSelectedPayeesDTO.name = `${key}.insuredPersonId`;
        pagedFilterSelectedPayeesDTO.value = this.payeeIds.toString();
        pagedFilterSelectedPayeesDTO.operator = 'in';
        pagedRequestDTO.fieldMap[key] = pagedFilterSelectedPayeesDTO;
      }
      else if (this.payeeTypeFormControl.value === PROVIDER) {
        const pagedFilterSelectedPayeesDTO = new PagedFilterDTO();
        pagedFilterSelectedPayeesDTO.name = 'providerByProviderId.providerId';
        pagedFilterSelectedPayeesDTO.value = this.payeeIds.toString();
        pagedFilterSelectedPayeesDTO.operator = 'in';
        pagedRequestDTO.fieldMap['providerByProviderId'] = pagedFilterSelectedPayeesDTO;
      }
    }

    const pagedFilterSelectedPayersDTO = new PagedFilterDTO();
    pagedFilterSelectedPayersDTO.name = 'productByProductId.payerId';
    pagedFilterSelectedPayersDTO.value = this.payeeIds && this.payeeIds.length > 0 ? this.payerIds.toString() : '-1';
    pagedFilterSelectedPayersDTO.operator = 'in';
    pagedRequestDTO.fieldMap['productByProductId_2'] = pagedFilterSelectedPayersDTO;

    const keySubClass = 'processingSubClassByProcessingSubClassId';
    if (this.processingSubClass != ALL_SUB_CLASSES && this.processingSubClass != null && this.processingSubClass !== '') {
      const pagedFilterSelectedSubClassDTO = new PagedFilterDTO();
      pagedFilterSelectedSubClassDTO.name = `${keySubClass}.name`;
      pagedFilterSelectedSubClassDTO.value = this.processingSubClass;
      pagedRequestDTO.fieldMap[keySubClass] = pagedFilterSelectedSubClassDTO;
    }

    this.claimService.getListOfClaims(pagedRequestDTO)
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe({
        next: (response: PagedResponseDTO<ClaimDisplayDTO>) => {
          this.transactionDataSource = response.resultList;
          this.transactionIdsList = null;
          if (this.transactionDataSource) {
            this.transactionDataSource.forEach(transaction => {
              if (this.showUpfrontPaidFormControl.value) {
                this.addSelectedTransaction(transaction);
              }
              else {
                if (this.getTransactionBankAccountByPayeeType(transaction) != null) {
                  this.addSelectedTransaction(transaction);
                  this.addToTotalAmount(transaction);
                }
              }
            });
          }
          this.transactionTableControl.length = response.totalRecords;
          if (this.transactionTableControl.length > 100) {
            this.pageSizeOptions.push(this.transactionTableControl.length);
          }
          else {
            this.pageSizeOptions = [5, 10, 25, 100];
          }
          this.transactionTableControl.pageSizeOptions = this.pageSizeOptions;
        },
        error: (errorResponse) => this.openErrorDialog( errorResponse?.error?.businessMessage)
      });
  }

  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.defaultProductFormControlSelectedValues(this.getProducts(), false);
      this.productSelectionChange(false);
    }
    else {
      this.productFormControl.setValue([]);
      this.clearPayeeDropBoxArrays();
    }
  }

  private getSelectedProductIds(): number[] {
    const productIds: number[] = [];
    const products: NameValueDTO[] = this.getProducts();
    products.filter(item => this.productFormControl.value.includes(item.name)).forEach(item => {
      productIds.push(item.value);
    });
    return productIds;
  }

  private getListOfPayees(searchText: string): void {
    const products = !this.allSelected?.selected ? this.productFormControl.value : [];
    const subClass = this.processingSubClass != ALL_SUB_CLASSES && !stringNullOrEmpty(this.processingSubClass) ? this.processingSubClass : '';

    // IF a PSS or RFLI product is selected, then the payer filter should be ignored
    const payerIdList = !this.productFormControl.value.find(product => String(product).includes('PSS') || String(product).includes('RFLI'))
      ? this.selectedPayers.map(payer => payer.payerId).toString() : '';

    const filterPayeesDTO: FilterPayeesDTO = {
      className: this.processingClassFormControl.value,
      payeeType: this.payeeTypeFormControl.value,
      name: searchText,
      toDate: this.datePipe.transform(this.claimToDateFormControl.value, 'yyyyMMdd'),
      fromDate: this.datePipe.transform(this.claimFromDateFormControl.value, 'yyyyMMdd'),
      payerIdList: payerIdList,
      subClassName: subClass,
      products: products,
      showUpfrontPaid: this.showUpfrontPaidFormControl.value
    };

    this.claimService.getPayeesWithClaims(filterPayeesDTO)
      .pipe(
        take(1),
      )
      .subscribe({
        next: (response) => this.availablePayees = response ?? [],
        error: (errorResponse) => this.sharedService.openErrorDialog(errorResponse?.error?.businessMessage)
      });
  }

  private getListOfPayers(searchText: string, isFirstTime: boolean = false): void {

    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblPayer;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = 50;

    const fieldMap: {} = {};
    const pagedFilterDTO = new PagedFilterDTO();

    pagedFilterDTO.name = 'name';
    pagedFilterDTO.value = searchText;
    fieldMap[pagedFilterDTO.name] = pagedFilterDTO;
    pagedRequestDTO.fieldMap = fieldMap;

    this.payerService.getListOfPayers(pagedRequestDTO)
      .pipe(
        take(1),
      )
      .subscribe({
        next: (response) => this.availablePayers = response.resultList,
        error: (errorResponse) => this.sharedService.openErrorDialog(errorResponse?.error?.businessMessage)
      });
  }

  private getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe({
      next: (response: NameValueDTO[]) => {
        this.medicalProducts = entity === this.lookupValue.MedicalProduct ? response : this.medicalProducts;
        this.funeralProducts = entity === this.lookupValue.FuneralProduct ? response : this.funeralProducts;
        this.processingSubClassesMedical = entity === this.lookupValue.ProcessingSubClassMedical ? (response != null ? response : []) : this.processingSubClassesMedical;
        this.processingSubClassesFuneral = entity === this.lookupValue.ProcessingSubClassFuneral ? (response != null ? response : []) : this.processingSubClassesFuneral;

        if (entity === this.lookupValue.MedicalProduct || entity === this.lookupValue.FuneralProduct) {
          this.defaultProductFormControlSelectedValues(response, true);
        }
      },
      error: (errorResponse) =>  this.sharedService.openErrorDialog(errorResponse?.error?.businessMessage)
    });
  }

  defaultProductFormControlSelectedValues(nameValueArray: NameValueDTO[], includeInitialFormControlValues: boolean): void {
    const newNamesToAdd = nameValueArray.map(item => item.name);
    const newArray = includeInitialFormControlValues ? [...this.productFormControl.value, ...newNamesToAdd] : newNamesToAdd;
    this.productFormControl.patchValue(newArray.includes(this.allProducts.name) ? [...newArray] : [...newArray, this.allProducts.name]);
  }

  private getListOfBankAccounts(): void {
    const payerIdList = this.selectedPayers && this.selectedPayers.length > 0 ? this.selectedPayers.map(payer => payer.payerId).toString() : null;
    const processingClassId = this.processingClassFormControl.value === ProcessingClassDisplayValue.Medical ? ProcessingClass.Medical : ProcessingClass.Funeral;
    const processingSubClassId = this.processingSubClass != ALL_SUB_CLASSES && this.processingSubClass != null && this.processingSubClass !== '' && this.getSubClasses().length > 0 ? this.getSubClasses().find(subClass => subClass.name == this.processingSubClass)?.value : null;
    let productId = null;

    // TODO: Handle this dynamically
    if (this.processingClassFormControl.value === ProcessingClassDisplayValue.Medical && this.getProducts().length > 0) {
      const productNames: string[] = this.productFormControl.value;
      // If ONLY PSS or ONLY RFLI is selected, then filter the bank accounts with teh product ID
      if ((productNames.find(product => product.includes('PSS')) || productNames.find(product => product.includes('RFLI'))) && productNames.length == 1) {
        const productIds = this.getSelectedProductIds();
        productId = productIds[0];
      }
    }

    const pagedRequestDTO = EntRequestBuilder.getListOfClientBankAccounts(payerIdList, null, processingClassId, processingSubClassId, productId);
    this.bankAccountService.getListOfBankAccounts(pagedRequestDTO)
      .pipe(
        take(1),
      )
      .subscribe({
        next: (response: PagedResponseDTO<BankAccountDTO>) => {
          this.fromBankAccounts = response.resultList ;
          if (this.fromBankAccounts && this.fromBankAccounts.length > 0) {
            this.fromBankAccountFormControl.setValue(this.getFromBankAccountDisplayString(this.fromBankAccounts[0]));
          }
        },
        error: (errorResponse) => this.sharedService.openSnackBar(errorResponse?.error?.businessMessage, 'Dismiss')
      });
  }

  private navigateToPaymentsPage(): void {
    if (!this.router) {
      return;
    }
    this.router.navigate(['/claim-management'], {queryParams: {tab: 'payments'}});
  }
}
